<div class="key-value">
    <div class="key">
        <div class="one-liner">
            <mat-checkbox *ngIf="item" [(ngModel)]="item.isChecked"></mat-checkbox>
            <a class="underlined" href="#" (click)="downloadInvoice($event)">{{ item?.invoiceID }}</a>
        </div>
    </div>
    <div class="value">
        <div class="chip {{ item?.status | invoiceStatusColor }}">{{ item?.status | uppercase }}</div>
    </div>
</div>
<div class="key-value vertical">
    <div class="key">Invoice Date:</div>
    <div class="value">{{ item?.invoiceDate }}</div>
</div>
<div class="key-value vertical">
    <div class="key">Due Date:</div>
    <div class="value">{{ item?.dueDate }}</div>
</div>
<div class="key-value">
    <div class="key">Balance:</div>
    <div class="value">${{ item?.balance | number:'0.2-2' }}</div>
</div>
<div class="key-value">
    <div class="key">Business:</div>
    <div class="value">{{ item?.business }}</div>
</div>
<div class="key-value">
    <div class="key">Earned Points:</div>
    <div class="value">{{ item?.points || "-" }}</div>
</div>
<div class="key-value">
    <div class="key"></div>
    <div class="value">
        <a class="one-liner" href="#" (click)="redeem($event)">
            <span>Redeem</span>
            <mat-icon>chevron_right</mat-icon>
        </a>
    </div>
</div>
